import React, { useState } from "react";
import { useEffect } from "react";
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import BadgeTwoToneIcon from '@mui/icons-material/BadgeTwoTone';
import PersonSearchTwoToneIcon from '@mui/icons-material/PersonSearchTwoTone';
import instance from "../../utilities/Instance";
import ProfileBase from "../../components/shared/layout/profileBaseSkeleton";
import TextField from '@mui/material/TextField';
import {
    AlertCodeInterpreter_Catch, AlertCodeInterpreter_Error,
    AlertCodeInterpreter_F,
    AlertConfirmStandard
} from "../../components/alerts";
import { generarForm, generarFormCompleto, isNumeric } from "../../utilities/Utilities";
import PersonasView from "./PersonasView";
import FormsEdit from "../../components/shared/layout/Forms";
import ResponseCustomizedSnackbars, { CatchResponseCustomizedSnackbars } from "../../components/shared/notification/snackbar";


export default function SkeletonPersona(props){
    const [datatable, setDataTable]= useState([]);
    const [actionsButtoms, setActionsButtoms]= useState([]);
    const [AditionalFields, setAditionalFields] =useState([]);
    const [formDataSearch, setFormDataSearch]= useState([]);
    const [formDataSelect, setFormDataSelect]= useState([]);
    const [formDataDate, setFormDataDate]= useState([]);
    const [formDataToggleSwitch, setFormDataToggleSwitch]= useState([]);
    const [formDataModalSearch, setFormDataModalSearch]= useState([]);
    const [theTitle, setTheTitle]=useState('Perfil');
    const [persona_id, setPersonaId]=useState(null)
    const [contadorSecuencias, setContador]=useState(0)
    const [title, setTitle]= useState("");
    const [rules,setRules]= useState([]);
    const [listCatalogos,setListCatalogos]= useState([]);
    const [selectListOptions, setSelectListOptions]= useState({})
    const [listPaises, setListPaises]= useState([]);
    const [listEstados, setListEstados]= useState([]);
    const [listCiudades, setListCiudades]= useState([]);
    const [datosPersona, setDatosPersona]= useState({});
    const [filter, setFilters] = useState({
      f_hermanas:false,
      f_SNID: false,
      f_fallecido: false,
      f_retirados: 'T',
    })

    
    const [dataresponse,setDataResponse]=useState(null)
    const [validatorDataresponse,setValidatorDataResponse]=useState(null)
    const [catchResponse,setCatchResponse]=useState(null)
    const [validatorCatchresponse,setValidatorCatchResponse]=useState(null)
    const [file, setFile] = useState("");
    
    const {setLoader, menu_id} = props;
    
    const DataResponseValid=(value)=>{
      setDataResponse(value)
      setValidatorDataResponse(!validatorDataresponse)
    }

    const CatchResponseValid=(value)=>{
      setCatchResponse(value)
      setValidatorCatchResponse(!validatorCatchresponse)
    }

    const actualizarRegistro = async (row, base) =>{
      setLoader(true);
      await instance.postForm(base,row)
      .then(async(response)=>{
        setLoader(false);
        if(! await AlertCodeInterpreter_F(response.data.data)){

        }
      }).catch(error =>{
        if(error?.response?.data?.error){
          AlertCodeInterpreter_Catch(error.response.data.error)
        }
        console.error(error)
        setLoader(false);
      })
    }

    const guardarRegistro = async (row) =>{
      const base="Persona/update/"+persona_id
      if(persona_id){
        if(file){
          row.foto=file;
        }
      }
      
      actualizarRegistro(row, base)

    }

    const createRow = async (row, newItem)=>{
      const insertEl={
          ...row,
        id: newItem || "",
        idreal: row?.id || null,
        numeroidentificacion: row?.numeroidentificacion ||"",
        apellidos: row?.apellidos ||"",
        nombres: row?.nombres ||"",
        nombrecompleto:row?.nombrecompleto ||"",
        telefono:row?.telefono ||"",
        telefonocelular:row?.telefonocelular || "",
        lugarnacimiento:row?.lugarnacimiento ||"",
        ciudadnatalidad_id:row?.ciudadnatalidad_id||"",
        ciudadnatalidad_detalle:row?.ciudadnatalidad_detalle||"",
        fechanacimiento:row?.fechanacimiento||"",
        ciudadresidencia_id:row?.ciudadresidencia_id||"",
        ciudadresidencia_detalle:row?.ciudadresidencia_detalle||"",
        correopersonal:row?.correopersonal||"",
        correointitucional:row?.correointitucional||"",
        ct_tipoidentificacion_id:row?.ct_tipoidentificacion_id||"",
        ct_tipoidentificacion_detalle:row?.ct_tipoidentificacion_detalle||"",
        ct_estadocivil:row?.ct_estadocivil||"",
        ct_estadocivil_detalle:row?.ct_estadocivil_detalle||"",
        ct_sexo:row?.ct_sexo||"",
        ct_sexo_detalle:row?.ct_sexo_detalle||"",
        discapacidad:row?.discapacidad||false,
        extranjero:row?.extranjero||false,
        observacion:row?.observacion||"",
        estado:row?.estado||false,
        fechacreacion:row?.fechacreacion||"",
        fechamodificacion:row?.fechamodificacion||"",
        fallecido: row?.fallecido||false,
        direccion:row?.direccion||"",
        codigo:row?.codigo||"",
      }
        return insertEl
    }

    const addRow = async(row) =>{
      const newItem= contadorSecuencias +1
      
      const aux= [...datatable]
      aux.push(await createRow(row, newItem))
      setContador(newItem)
      setDataTable(aux)
    }

    const deleteId = async (id) => {
        setLoader(true)

        const confirmation = await AlertConfirmStandard({content: "¿Desea eliminar a esta persona?"}, '4')
        if (confirmation) {
            if (confirmation.value){
                await instance.get("Persona/RemoveById/"+id)
                    .then(async (response) => {
                        if (await AlertCodeInterpreter_F(response.data.data)) {
                            setPersonaId(0)
                            resetAll()
                        }
                    })
                    .catch((error) => {
                        if(error?.response?.data?.error){
                            AlertCodeInterpreter_Catch(error.response.data.error)
                        }
                        else if(error?.response?.data?.data) {
                            AlertCodeInterpreter_Error(error.response.data)
                        }
                        console.error(error);
                    })
                    .finally(() => {
                        getData();
                        getDataAll();
                        setLoader(false)
                    })
                return true
            }
        }
        setLoader(false)
        return false;
    }

    const SearchId= async(e)=>{
      setLoader(true);
      await instance.get("Persona/FindByIdPerfilComplete/"+e)
      .then(async(response)=>{
        setLoader(false);
      if(! await AlertCodeInterpreter_F(response.data.data)){
        await setterSearch(response)
      }else{
        setPersonaId(0)
        resetAll()
      }
      
      }).catch((error)=>{
        if(error?.response?.data?.error){
          AlertCodeInterpreter_Catch(error.response.data.error)
        }
        console.error(error)
      })
      setLoader(false);
    }

    const SearchCedula= async(e)=>{
      setLoader(true);
      await instance.get("Persona/FindByIdentidadPerfilComplete/"+e)
      .then(async(response)=>{
        setLoader(false);
      if(! await AlertCodeInterpreter_F(response.data.data)){
        await setterSearch(response)
      }else{
        setPersonaId(0)
        resetAll()
      }
      
      }).catch((error)=>{
        if(error?.response?.data?.error){
          AlertCodeInterpreter_Catch(error.response.data.error)
        }
        console.error(error)
      })
      setLoader(false);
    }

    const setterSearch= async(response)=>{
      let datosPersona= response.data.data.data;
      delete datosPersona.nombrecompleto;

      if(Array.isArray(datosPersona)){
        const datosform=[]
        let newItem= contadorSecuencias
        datosPersona.forEach(async element => {
          newItem= newItem+1
          datosform.push(await createRow(element, newItem))
        });

        setDataTable(datosform)
        setContador(newItem)
        response.data.data.form =datosform
        setPersonaId(0)
      }else{
        if(!datosPersona){
          datosPersona={}
        }
        const idp =datosPersona?.id
        setPersonaId(idp)
        let newItem= contadorSecuencias
        let datosform=[]
        newItem= newItem+1
        datosform.push(await createRow(datosPersona, newItem))
        setContador(newItem)
        delete datosPersona?.id;
        setDataTable(datosform)
        
        datosform=generarForm(datosPersona);
        const datosprueba= generarFormCompleto(datosPersona);
        const dictionaryRuleCatalogo=rules.find((rule)=>rule.nombre==="Catalogo parent")?.configuracion
        datosprueba.selectfield.forEach(element => {
          element.padre=dictionaryRuleCatalogo[element.paridad.name]
          element.padrefield="catalogo_id"
        });
        
        let generalform={}
        await setFormDataSearch(datosprueba.textfield || []);
        
        await setFormDataSelect(datosprueba.selectfield || []);
        await setFormDataDate(datosprueba.DateTimeField || []);
        await setFormDataToggleSwitch(datosprueba.ToggleSwitchField || []);
        await setFormDataModalSearch(datosprueba.modalSearch || [])

        datosform.forEach(element => {
          generalform={...generalform, [element.name]:element.value}
        });
        await setDatosPersona(generalform)
        setFile(response.data.data?.data?.foto ||'')
        
      }
    }

    const resetAll=()=>{
      setFile('')
      setFormDataSearch([]);
        
      setFormDataSelect( []);
      setFormDataDate( []);
      setFormDataToggleSwitch( []);
      setFormDataModalSearch( [])
    }

    const SearchName= async(e)=>{
      setLoader(true);
      await instance.get("Persona/FindByNombrePerfilComplete/"+e)
      .then(async(response)=>{
        setLoader(false);
      if(! await AlertCodeInterpreter_F(response.data.data)){
        
        await setterSearch(response)

      }else{
        setPersonaId(0)
        resetAll()
        //setDataTable([])
      }
      
      }).catch((error)=>{
        if(error?.response?.data?.error){
          AlertCodeInterpreter_Catch(error.response.data.error)
        }
        console.error(error)
      })
      setLoader(false);
    } 

    const openEdit = async(e)=>{
      if(e.numeroidentificacion){
        SearchCedula(e.numeroidentificacion)
      }else{
        if(e.idreal){
          SearchId(e.idreal)
        }
      }

    }
    const openDelete = async(e)=>{
        const response = await instance.get(`Usuario/SearchUsuariosByNombre/${e.nombrecompleto}`)

        const usuarios = (response.data?.data?.error ?? true) ? null : response.data?.data?.codecase === 222 ? response.data?.data?.data?.find(x => x.persona_id === e.idreal) : response.data?.data?.data;

        if (!usuarios) {
            if(e.idreal){
                await deleteId(e.idreal)
            }
        }
        else {
            await AlertCodeInterpreter_F({
                codecase: '11',
                title: "Usuario registrado",
                content: "No puede borrar una persona que tiene un usuario enlazado."
            });
        }
    }

    const handleChange = (e) =>{
      const datosPers= {...datosPersona}
      datosPers[e.target.name]=e.target.value
      setDatosPersona(datosPers)
    }

    const handleSelect = (e) =>{
      const datosPers= {...datosPersona}
    }


    const ActionsHandle = async(e) =>{
      e.preventDefault();
      let opt = e.nativeEvent.submitter.value;
      
      const data = new FormData(e.currentTarget);
      const toSend={
        busqueda: data.get('busqueda')
      }
      if(!toSend.busqueda?.length){
        getDataAll()
        return
      }
      if( isNumeric(toSend.busqueda)){
        opt = "cedula"
      }else{{
        opt = "nombre"
      }}
      if(opt==='cedula'){
        await SearchCedula(toSend.busqueda)
      }else
      if(opt==='nombre'){
        SearchName(toSend.busqueda)
      }
    }

    const SubmitHandle = async(e) =>{
        e.preventDefault();

        if (e.nativeEvent.submitter.name === "submitPersona") {
          const data = new FormData(e.currentTarget);
          let toSend={}
          formDataSearch.forEach(element => {
            toSend[element.name]=data.get(element.name)
          });

          toSend={...datosPersona}

          guardarRegistro(toSend)
        }

        if (e.nativeEvent.submitter.name === "deletePersona") {
            if (await deleteId(persona_id)) {
                setPersonaId(0)
                resetAll()
            }
        }
    }

    const getDataAll= async(e)=>{
      setLoader(true)
      await instance.get("Persona/ListAll")
      .then(async(response)=>{
          let para=[]
          if( response.data.data.length>0){
            const registros= response.data.data;
            let newItem= contadorSecuencias
            registros.forEach(async (element) => {
              newItem= newItem+1
              para.push(await createRow(element, newItem))
            });
            setContador(newItem)
            setDataTable(para)
          }
        })
        .catch((error)=>{
          if(error?.response?.data?.error){
              AlertCodeInterpreter_Catch(error.response.data.error)
            }
            console.error(error)
        })
        setLoader(false)
  }

    const getData=async()=>{
      const botones = []
      botones.push({icon:<BadgeTwoToneIcon titleAccess="Nùmero de identidad" />,
                    value: "cedula"})
      botones.push({icon: <PersonSearchTwoToneIcon titleAccess="Nombre" />,
                    value: "nombre"})
      setActionsButtoms(botones)

      const AdicionalFields = (
        <React.Fragment>
          <TextField
                margin="normal"
                required
                fullWidth
                id="busqueda"
                label="Buscar"
                name="busqueda"
                autoComplete="busqueda"
                autoFocus
              />
        </React.Fragment>
          
      )
      
      setAditionalFields(AdicionalFields)

      const listaOpciones={}
      await instance.get("DataMaster/getAllSelectors")
      .then(async response=>{
        listaOpciones.detallecatalogo=response?.data?.data?.DetalleCatalogos ||[]
        listaOpciones.listCiudades=response?.data?.data?.Ciudades ||[]
        setSelectListOptions(listaOpciones)
        setListPaises(response?.data?.data?.Paises ||[])
        setListEstados(response?.data?.data?.Estados ||[])
        setListCiudades(response?.data?.data?.Ciudades ||[])
        setListCatalogos(response?.data?.data?.Catalogos ||[])
        setRules(response?.data?.data?.Config ||[])
      }).catch((error)=>{
        if(error?.response?.data?.error){
          AlertCodeInterpreter_Catch(error.response.data.error)
        }
        console.error(error)
      })
    }

    useEffect(()=> {
      getData();
      getDataAll();
    }, [])

    const imageUp= (e) => {
      if(!persona_id){
        setFile({})
        return
      }
      const reader = new FileReader();
      const fname=e.target.files[0];

      if(e.target.files[0].type==="image/png" || e.target.files[0].type==="image/jpg" || e.target.files[0].type==="image/jpeg"){
        if(e.target.files[0].size>1000000){
          reader.onloadend = function() {
            setFile( reader.result)
          }
          reader.readAsDataURL(fname);
           AlertCodeInterpreter_F({error:true, codecase: 11, title: 'Archivo muy pesado', content: 'Asegúrate de subir un archivo con peso menor a 1Mb'})
        }else{
          reader.onloadend = function() {
            setFile( reader.result)
          }
          reader.readAsDataURL(fname);
        }
        
      }
    }

    
    
    return (
        <React.Fragment>
            <Grid container spacing={3}>
            <ResponseCustomizedSnackbars dataresponse={dataresponse} validator={ validatorDataresponse}/>
            <CatchResponseCustomizedSnackbars dataresponse={catchResponse} validator={validatorCatchresponse}/>
            
              {/* Perfil Search y options */}
              <Grid item xs={12} md={4} lg={3} >
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    alignItems: "center",
                  }}
                >
                  {<ProfileBase 
                    idreferencia={persona_id}
                    title={theTitle}
                    actionsButtoms={actionsButtoms} 
                    titleSelect= {"Buscar por:"} 
                    imageUp={imageUp}
                    imageBg={file}
                    AditionalFields={AditionalFields}
                    ActionsHandle={ActionsHandle}  
                  />}
                </Paper>
              </Grid>
              {/* Perfil datos */}
              <Grid item xs={12} md={8} lg={9}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <PersonasView
                    filters={filter}
                    setFilters={setFilters}
                    openEdit={openEdit}
                    openDelete={openDelete}
                    getData={getDataAll}
                    setDataResponse={DataResponseValid} setCatchResponse={CatchResponseValid}
                    data={datatable}
                    title={title}
                    addRow={addRow}
                    menu_id={menu_id}
                    /> 
                    
                </Paper>
              </Grid>
              {/* Tablas */}
              <Grid item xs={12}>
              <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                >
                  {(persona_id?true:false) &&<FormsEdit textFields={formDataSearch}
                    tipoDocumento={[{id:61, title: 'CÉDULA', name: 'ceduladoc_id', fromText:'cedulanombre'}, {id:62, title: 'PASAPORTE',name: 'pasaportedoc_id', fromText:'pasaportenombre'}]}
                    idreferencia={persona_id}
                    specialRules={rules}
                    DateFields={formDataDate}
                    selectFields={formDataSelect} 
                    toggleSwitchFields={formDataToggleSwitch} 
                    ModalSearchFields={formDataModalSearch}
                    handleChange={handleChange} 
                    formData={datosPersona}
                    SubmitHandle={SubmitHandle}
                    handleSelect={handleSelect}
                    selectListOptions={selectListOptions}
                    listPaises={listPaises}
                    listEstados={listEstados}
                    listCiudades={listCiudades}
                    showDeleteButton
                    />}
                  {/*<Chart />*/}
                </Paper>
                
              </Grid>
            </Grid>
        </React.Fragment>
    )
}